import { Component, Inject, Input, OnInit, Optional } from '@angular/core';
import { IPopupScreenData } from 'src/app/common/models/popup-screen-data.model';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TransactionDetail } from 'src/app/models/transaction-detail.model';


@Component({
  selector: 'app-transaction-details-form',
  templateUrl: './transaction-details-form.component.html',
  styleUrls: ['./transaction-details-form.component.scss']
})
export class TransactionDetailsFormComponent implements OnInit{
  @Input() transactionInfo:TransactionDetail 
  @Inject(MAT_DIALOG_DATA) protected data: IPopupScreenData
  popupData:any;
  // flag:any;
  constructor( 
  ) {
   
  }
  ngOnInit(): void {
    this.popupData = this.data?.screenData?.data;
    //  this.flag = this.popupData.dbcrFlag;
    // console.log("popupdata",this.flag);
    
  }

}

